import moment from "moment";
import idsFluxosProcessos from "../../../../helpers/idsFluxosProcessos";
import { formatarCPFCNPJ } from "../../../../helpers/masks";

export function generateLabelInfo(identificador: string, extras: any): string {

    const labelGenerators: Record<string, () => string> = {
        [idsFluxosProcessos.analiseCredito]: () =>
            `${extras.tipo_publico}${extras.codigo_publico}${extras.nome ? " - " + extras.nome : ""}`,

        [idsFluxosProcessos.criacaoTituloPagar]: () =>
            `${extras.tipo_publico}${extras.codigo_publico}${extras.nome ? " - " + extras.nome : ""}`,

        [idsFluxosProcessos.solicitRessuprimento]: () => {
            const qtdItens = extras.items.length;
            return `${qtdItens} ${qtdItens > 1 ? "itens" : "item"} solicitados`;
        },

        [idsFluxosProcessos.cancelarRecibo]: () =>
            `Recibo - ${extras.numero_recibo} - ${moment(extras.titulos[0].data_recibo).format("DD/MM/YYYY")}`,

        [idsFluxosProcessos.criacaoApGlobal]: () =>
            `Número AP: ${extras.numero_ap}`,

        [idsFluxosProcessos.criacaoCooperado]: () =>
            `Documento: ${formatarCPFCNPJ(extras.cpf_cnpj)}<br />Nome: ${extras.nome_publico}`,
    };

    return labelGenerators[identificador]?.() || "-";
}